"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = require("@emotion/react");

var _theme = require("@zip/theme");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var SvgNothingToPay = function SvgNothingToPay(_ref) {
  var title = _ref.title,
      props = _objectWithoutProperties(_ref, ["title"]);

  var theme = (0, _react.useTheme)();

  switch (theme.name) {
    case _theme.fearlessBusiness.name:
      return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
        viewBox: "0 0 110 100",
        fill: "none"
      }, props), {}, {
        children: [title ? (0, _jsxRuntime.jsx)("title", {
          children: title
        }) : null, (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M84.1 83.504H29.076a8.4 8.4 0 01-8.4-8.4V29.389a4.84 4.84 0 014.839-4.838H84.1a4.84 4.84 0 014.839 4.838v49.278a4.84 4.84 0 01-4.839 4.838zM11.35 66.94H4.336a1.612 1.612 0 110-3.227h7.012c.892 0 1.613.721 1.613 1.613s-.72 1.613-1.613 1.613z",
          fill: "#D0EEFD"
        }), (0, _jsxRuntime.jsx)("mask", {
          id: "nothingToPay_svg__a",
          maskUnits: "userSpaceOnUse",
          x: 59,
          y: 96,
          width: 12,
          height: 4,
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M59.945 96.41h10.239v3.226H59.945v-3.225z",
            fill: "#fff"
          })
        }), (0, _jsxRuntime.jsx)("g", {
          mask: "url(#nothingToPay_svg__a)",
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M68.571 99.637h-7.013a1.612 1.612 0 110-3.226h7.013c.892 0 1.613.72 1.613 1.613 0 .892-.72 1.613-1.613 1.613z",
            fill: "#D0EEFD"
          })
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.625 72.387H1.613a1.612 1.612 0 110-3.225h7.012a1.611 1.611 0 110 3.226z",
          fill: "#D0EEFD"
        }), (0, _jsxRuntime.jsx)("mask", {
          id: "nothingToPay_svg__b",
          maskUnits: "userSpaceOnUse",
          x: 96,
          y: 1,
          width: 13,
          height: 13,
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M96.475 1.614h11.799v11.798h-11.8V1.614z",
            fill: "#fff"
          })
        }), (0, _jsxRuntime.jsx)("g", {
          mask: "url(#nothingToPay_svg__b)",
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M106.662 5.9h-2.674V3.228c0-.892-.721-1.613-1.613-1.613s-1.613.72-1.613 1.613V5.9h-2.674c-.892 0-1.613.72-1.613 1.613 0 .892.72 1.613 1.613 1.613h2.674v2.672c0 .892.721 1.613 1.613 1.613s1.613-.72 1.613-1.613V9.127h2.674c.892 0 1.613-.721 1.613-1.613s-.721-1.613-1.613-1.613z",
            fill: "#D0EEFD"
          })
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M89.47 76.522H30.884a3.23 3.23 0 01-3.226-3.226V34.412h48.778a1.612 1.612 0 100-3.225H27.658v-7.168a3.23 3.23 0 013.226-3.226h8.994c-.134.6-.305 1.216-.537 1.853a1.613 1.613 0 103.03 1.105c.371-1.016.639-2.005.808-2.958h10.849c-.134.6-.303 1.216-.537 1.853a1.614 1.614 0 003.03 1.105c.373-1.016.64-2.005.808-2.958h10.85c-.133.6-.304 1.216-.537 1.853a1.613 1.613 0 103.03 1.105c.372-1.016.64-2.005.809-2.958h10.848c-.133.6-.303 1.216-.537 1.853a1.614 1.614 0 003.03 1.105c.373-1.016.641-2.005.809-2.958h3.839a3.23 3.23 0 013.225 3.226v7.168h-7.322a1.612 1.612 0 100 3.226h7.322v38.883a3.23 3.23 0 01-3.225 3.226zm0-58.955h-3.678c-.132-1.582-.593-3.003-1.417-4.182-1.31-1.87-3.34-2.898-5.715-2.898a1.612 1.612 0 100 3.226c1.311 0 2.374.525 3.071 1.522.445.636.716 1.427.826 2.332H71.64c-.133-1.582-.594-3.003-1.418-4.182-1.308-1.87-3.337-2.898-5.715-2.898a1.612 1.612 0 100 3.225c1.313 0 2.375.526 3.073 1.523.444.636.716 1.427.824 2.332H57.491c-.131-1.582-.594-3.005-1.418-4.184-1.308-1.867-3.336-2.896-5.713-2.896a1.612 1.612 0 100 3.226c1.311 0 2.373.525 3.07 1.52.445.636.717 1.43.825 2.334H43.34c-.13-1.582-.593-3.005-1.416-4.184-1.308-1.867-3.337-2.896-5.713-2.896a1.612 1.612 0 100 3.226c1.311 0 2.371.525 3.07 1.52.443.636.715 1.43.825 2.334h-9.22a6.458 6.458 0 00-6.452 6.452v49.277a6.458 6.458 0 006.451 6.452H89.47a6.458 6.458 0 006.451-6.452V24.02a6.458 6.458 0 00-6.451-6.452z",
          fill: "#124099"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M69.023 48.05l-10.42 10.42-4.64-4.64c-.63-.631-1.65-.631-2.28 0-.63.63-.63 1.65 0 2.28l5.78 5.78a1.608 1.608 0 002.281 0l11.56-11.559c.63-.63.63-1.65 0-2.28-.63-.631-1.65-.631-2.28 0z",
          fill: "#124099"
        })]
      }));

    default:
      return (0, _jsxRuntime.jsxs)("svg", _objectSpread(_objectSpread({
        viewBox: "0 0 110 100",
        fill: "none"
      }, props), {}, {
        children: [title ? (0, _jsxRuntime.jsx)("title", {
          children: title
        }) : null, (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M84.1 83.504H29.076a8.4 8.4 0 01-8.4-8.4V29.389a4.84 4.84 0 014.839-4.838H84.1a4.84 4.84 0 014.839 4.838v49.278a4.84 4.84 0 01-4.839 4.838zM11.35 66.94H4.336a1.612 1.612 0 110-3.227h7.012c.892 0 1.613.721 1.613 1.613s-.72 1.613-1.613 1.613z",
          fill: "#EDE6FF"
        }), (0, _jsxRuntime.jsx)("mask", {
          id: "nothingToPay_svg__a",
          maskUnits: "userSpaceOnUse",
          x: 59,
          y: 96,
          width: 12,
          height: 4,
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M59.945 96.41h10.239v3.226H59.945v-3.225z",
            fill: "#fff"
          })
        }), (0, _jsxRuntime.jsx)("g", {
          mask: "url(#nothingToPay_svg__a)",
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M68.571 99.637h-7.013a1.612 1.612 0 110-3.226h7.013c.892 0 1.613.72 1.613 1.613 0 .892-.72 1.613-1.613 1.613z",
            fill: "#EDE6FF"
          })
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M8.625 72.387H1.613a1.612 1.612 0 110-3.225h7.012a1.611 1.611 0 110 3.226z",
          fill: "#EDE6FF"
        }), (0, _jsxRuntime.jsx)("mask", {
          id: "nothingToPay_svg__b",
          maskUnits: "userSpaceOnUse",
          x: 96,
          y: 1,
          width: 13,
          height: 13,
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M96.475 1.614h11.799v11.798h-11.8V1.614z",
            fill: "#fff"
          })
        }), (0, _jsxRuntime.jsx)("g", {
          mask: "url(#nothingToPay_svg__b)",
          children: (0, _jsxRuntime.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M106.662 5.9h-2.674V3.228c0-.892-.721-1.613-1.613-1.613s-1.613.72-1.613 1.613V5.9h-2.674c-.892 0-1.613.72-1.613 1.613 0 .892.72 1.613 1.613 1.613h2.674v2.672c0 .892.721 1.613 1.613 1.613s1.613-.72 1.613-1.613V9.127h2.674c.892 0 1.613-.721 1.613-1.613s-.721-1.613-1.613-1.613z",
            fill: "#EDE6FF"
          })
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M89.47 76.522H30.884a3.23 3.23 0 01-3.226-3.226V34.412h48.778a1.612 1.612 0 100-3.225H27.658v-7.168a3.23 3.23 0 013.226-3.226h8.994c-.134.6-.305 1.216-.537 1.853a1.613 1.613 0 103.03 1.105c.371-1.016.639-2.005.808-2.958h10.849c-.134.6-.303 1.216-.537 1.853a1.614 1.614 0 003.03 1.105c.373-1.016.64-2.005.808-2.958h10.85c-.133.6-.304 1.216-.537 1.853a1.613 1.613 0 103.03 1.105c.372-1.016.64-2.005.809-2.958h10.848c-.133.6-.303 1.216-.537 1.853a1.614 1.614 0 003.03 1.105c.373-1.016.641-2.005.809-2.958h3.839a3.23 3.23 0 013.225 3.226v7.168h-7.322a1.612 1.612 0 100 3.226h7.322v38.883a3.23 3.23 0 01-3.225 3.226zm0-58.955h-3.678c-.132-1.582-.593-3.003-1.417-4.182-1.31-1.87-3.34-2.898-5.715-2.898a1.612 1.612 0 100 3.226c1.311 0 2.374.525 3.071 1.522.445.636.716 1.427.826 2.332H71.64c-.133-1.582-.594-3.003-1.418-4.182-1.308-1.87-3.337-2.898-5.715-2.898a1.612 1.612 0 100 3.225c1.313 0 2.375.526 3.073 1.523.444.636.716 1.427.824 2.332H57.491c-.131-1.582-.594-3.005-1.418-4.184-1.308-1.867-3.336-2.896-5.713-2.896a1.612 1.612 0 100 3.226c1.311 0 2.373.525 3.07 1.52.445.636.717 1.43.825 2.334H43.34c-.13-1.582-.593-3.005-1.416-4.184-1.308-1.867-3.337-2.896-5.713-2.896a1.612 1.612 0 100 3.226c1.311 0 2.371.525 3.07 1.52.443.636.715 1.43.825 2.334h-9.22a6.458 6.458 0 00-6.452 6.452v49.277a6.458 6.458 0 006.451 6.452H89.47a6.458 6.458 0 006.451-6.452V24.02a6.458 6.458 0 00-6.451-6.452z",
          fill: "#6542BE"
        }), (0, _jsxRuntime.jsx)("path", {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M69.023 48.05l-10.42 10.42-4.64-4.64c-.63-.631-1.65-.631-2.28 0-.63.63-.63 1.65 0 2.28l5.78 5.78a1.608 1.608 0 002.281 0l11.56-11.559c.63-.63.63-1.65 0-2.28-.63-.631-1.65-.631-2.28 0z",
          fill: "#6542BE"
        })]
      }));
  }
};

var _default = SvgNothingToPay;
exports["default"] = _default;